import ContainedButtonView from './contained-button-view'

const ContainedButtonContainer = ContainedButtonView

export default ContainedButtonContainer
